import { useEffect, useState } from "react";

export const useDebounceValue = <T>(value: T, delay: number = 200) => {
  const [willChangeData, setWillChangeData] = useState<T>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setWillChangeData(value);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value]);

  return willChangeData;
};
